document.addEventListener('DOMContentLoaded', function() {
    $(document).on("click", "quick-add-dialog .cstm-klaviyo-bis-trigger", function (e) {
    e.preventDefault();

    const p_id = $(this).attr("data-klaviyo-product-id");

    console.log("cstm----", p_id);

    const form_html = $(`product-card[data-product-id="${p_id}"]`)
        .eq(0)
        .find(".notify-form-wrapper")
        .html();

    $(".cstm-popup-modal").html(form_html);
    $("quick-add-dialog button[ref='closeButton']").trigger("click");
    setTimeout(() => {
        $(".cstm-popup-modal").addClass("active")
    }, 100);
    
});

$(document).on("click", ".cstm-klaviyo-bis-modal .klaviyo-bis-close", function (e) {
  e.preventDefault()
    $(".cstm-popup-modal").removeClass("active")
});

$(document).on("click", function (e) {
  // Check if click is outside the modal container
  if (
    !$(e.target).closest(".cstm-klaviyo-bis-modal #container").length
  ) {
    $(".cstm-popup-modal").removeClass("active");
  }
});

$(document).on("submit", ".cstm-klaviyo-bis-modal form", function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $form = $(this);
  const v_id  = $form.find("select#variants").val();
  const email = $form.find("input[type='email']").val();

  fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=bMhPfe", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "revision": "2023-12-15"
    },
    body: JSON.stringify({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${v_id}`
            }
          }
        }
      }
    })
  })
  .then((response) => {
    // ✅ 202 is success — Klaviyo returns empty body so never call .json()
    if (response.status === 202 || response.ok) {
      console.log("Klaviyo BIS success");
      $(".cstm-popup-modal .cstm-klaviyo-bis-modal #completed_message").show();
       $(".cstm-popup-modal button[type='submit']").hide();
    } else {
      // only try to parse body if there's actually an error response
      return response.json().then((err) => {
        console.error("Klaviyo BIS error:", err);
      });
    }
  })
  .catch((error) => {
    console.error("Klaviyo BIS error:", error);
  });
});
});